import { duration } from "@formant/core/model/duration";

import { DeadlineReachedError } from "./DeadlineReachedError";

export class DeadlineEnforcer {
    // we add a little bit of buffer time to make sure the gRPC web proxy has time to respond to its deadline
    private static readonly grpcCallDeadlineSlopMs = 500 * duration.millisecond;

    static withDeadline<T>(
        request: Promise<T>,
        deadlineMs: number,
    ): Promise<T> {
        const deadlineMetPromise = new Promise<T>((_, reject) => {
            setTimeout(() => {
                reject(
                    new DeadlineReachedError(
                        deadlineMs,
                        this.grpcCallDeadlineSlopMs,
                    ),
                );
            }, deadlineMs + this.grpcCallDeadlineSlopMs);
        });

        return Promise.race([request, deadlineMetPromise]);
    }
}
